/* unplugin-vue-components disabled */import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, unref as _unref, resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createSlots as _createSlots, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = /*#__PURE__*/_createElementVNode("img", {
  src: "/img/login_logo.png",
  alt: "",
  style: {
    "height": "29px"
  }
}, null, -1);
const _hoisted_2 = [_hoisted_1];
const _hoisted_3 = ["title"];
import useRequest from "@packages/share/use/useRequest";
import localforage from "localforage";
import reg from "@packages/share/utils/reg";
export default /*#__PURE__*/_defineComponent({
  __name: 'Login',
  setup(__props) {
    const $controller = inject("$controller");
    const router = useRouter();
    const route = useRoute();
    const errorMsg = ref("");
    const isPwd = ref(true); //输入框密码是否可视
    const curIndex = ref(0);
    // 清除缓存
    localStorage.clear();
    //用户登录传参
    const userInfo = reactive({
      password: "",
      userName: ""
    });
    //登录
    function onUserLogin() {
      localStorage.clear();
      localforage.clear();
      if (!userInfo.userName) {
        errorMsg.value = "请输入账号";
        return;
      }
      if (!userInfo.password) {
        errorMsg.value = "请输入密码";
        return;
      }
      if (!reg.nwePwd.test(userInfo.password)) {
        errorMsg.value = "密码10-16位，包含大小写字母、数字、特殊字符，不能包含中文";
        return;
      }
      errorMsg.value = "";
      let para = JSON.parse(JSON.stringify(userInfo));
      para.password = para.password.trim();
      para.userName = para.userName.trim();
      useRequest({
        api: "/mzc-user/account/loginForPC",
        para: para,
        manual: false,
        hasPager: false,
        tip: false,
        preProcess: data => {
          if (data.realName == "开发人员") {
            data.menuList = [{
              childList: [{
                childList: [{
                  childList: [],
                  icon: "",
                  id: "1572153427088265218",
                  menuActionList: [],
                  name: "系统菜单",
                  pid: "1571797421858639874",
                  status: 1,
                  url: "/zzmenu",
                  weight: 0
                }, {
                  childList: [],
                  icon: "",
                  id: "1572153488534818818",
                  menuActionList: [],
                  name: "系统角色",
                  pid: "1571797421858639874",
                  status: 1,
                  url: "/zzrole",
                  weight: 0
                }],
                icon: "",
                id: "1571797421858639874",
                menuActionList: [],
                name: "权限管理",
                pid: "1561621566108848130",
                status: 1,
                url: "",
                weight: 0
              }],
              icon: "1",
              id: "1561621566108848130",
              menuActionList: [],
              name: "基础中心",
              pid: "0",
              status: 1,
              url: "123123",
              weight: 1
            }];
          }
          let fn = obj => {
            obj.forEach(item => {
              item.childs = item.childList || [];
              item.actions = [];
              if (item.menuActionList && item.menuActionList.length) {
                item.actions = item.menuActionList || [];
                delete item.menuActionList;
              }
              delete item.childList;
              if (item.childs && item.childs.length) {
                fn(item.childs);
              }
            });
          };
          fn(data.menuList);
          localStorage.clear();
          localforage.clear().then(() => {
            localStorage.setItem("realName", data.realName); //如果是 "realName": "开发人员"，则有配置菜单的权限
            localStorage.setItem("cur-system", JSON.stringify({
              childs: data.menuList,
              name: "美赞臣",
              roleCode: data.roleCode
            })); //如果是 "realName": "开发人员"，则有配置菜单的权限
            localStorage.setItem("token", data.token); //如果是 "realName": "开发人员"，则有配置菜单的权限
            router.push({
              path: "/"
            });
          });
        },
        errorProcess: res => {
          errorMsg.value = res;
        }
      });
    }
    //找回密码
    function onFindPwd() {
      router.push("/findpwd");
    }
    return (_ctx, _cache) => {
      const _component_Write = _resolveComponent("Write");
      const _component_FormItem = _resolveComponent("FormItem");
      const _component_Icon = _resolveComponent("Icon");
      const _component_Form = _resolveComponent("Form");
      const _component_Btn = _resolveComponent("Btn");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", {
        class: _normalizeClass(_ctx.css.body),
        id: "login"
      }, [_createElementVNode("div", {
        class: _normalizeClass(_ctx.css.step1_text)
      }, _hoisted_2, 2), _createElementVNode("div", {
        class: _normalizeClass(_ctx.css.lo)
      }, [_createElementVNode("div", {
        class: _normalizeClass(_ctx.css.box)
      }, [_createElementVNode("div", {
        class: _normalizeClass(_ctx.css.form)
      }, [_withDirectives(_createElementVNode("div", null, [_createElementVNode("div", {
        class: _normalizeClass(_ctx.css.text_title)
      }, "账号登录", 2), _createVNode(_component_Form, {
        titlePosition: "top",
        model: _unref(userInfo)
      }, {
        default: _withCtx(() => [_createVNode(_component_FormItem, {
          label: "账号",
          prop: "userName"
        }, {
          default: _withCtx(() => [_createVNode(_component_Write, {
            class: _normalizeClass(_ctx.css.ipt),
            modelValue: _unref(userInfo).userName,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _unref(userInfo).userName = $event),
            modelModifiers: {
              trim: true
            },
            block: "",
            autofocus: "",
            placeholder: "请输入账号",
            onKeydown: _cache[1] || (_cache[1] = _withKeys($event => onUserLogin(), ["enter"]))
          }, null, 8, ["class", "modelValue"])]),
          _: 1
        }), _createVNode(_component_FormItem, {
          label: "密码",
          prop: "password"
        }, {
          default: _withCtx(() => [_createVNode(_component_Write, {
            modelValue: _unref(userInfo).password,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => _unref(userInfo).password = $event),
            modelModifiers: {
              trim: true
            },
            placeholder: "请输入登录密码",
            type: _unref(isPwd) ? 'password' : 'text',
            onKeydown: _cache[5] || (_cache[5] = _withKeys($event => onUserLogin(), ["enter"]))
          }, _createSlots({
            _: 2
          }, [_unref(userInfo).password ? {
            name: "default",
            fn: _withCtx(() => [_unref(isPwd) ? (_openBlock(), _createBlock(_component_Icon, {
              key: 0,
              name: "icon-shangpinyun_yincang",
              class: _normalizeClass([_ctx.css.icon, "mr_2"]),
              fontClassName: "iconfont",
              color: "#CCCCCC",
              onClick: _cache[2] || (_cache[2] = $event => isPwd.value = false)
            }, null, 8, ["class"])) : (_openBlock(), _createBlock(_component_Icon, {
              key: 1,
              name: "icon-shangpinyun_chakan",
              class: _normalizeClass([_ctx.css.icon, "mr_2"]),
              fontClassName: "iconfont",
              color: "#CCCCCC",
              onClick: _cache[3] || (_cache[3] = $event => isPwd.value = true)
            }, null, 8, ["class"]))]),
            key: "0"
          } : undefined]), 1032, ["modelValue", "type"])]),
          _: 1
        })]),
        _: 1
      }, 8, ["model"]), _createElementVNode("div", {
        class: _normalizeClass([[_ctx.css.forget_pwd, _ctx.css.href], "text_right"]),
        onClick: onFindPwd
      }, "忘记密码", 2), _createElementVNode("div", {
        class: _normalizeClass([_ctx.css.errorMsg, "ellipsis"]),
        title: _unref(errorMsg)
      }, _toDisplayString(_unref(errorMsg)), 11, _hoisted_3), _createElementVNode("div", null, [_createVNode(_component_Btn, {
        block: "",
        class: _normalizeClass(_ctx.css.btn),
        type: "primary",
        onClick: _cache[6] || (_cache[6] = $event => onUserLogin())
      }, {
        default: _withCtx(() => [_createTextVNode(" 登录 ")]),
        _: 1
      }, 8, ["class"])])], 512), [[_vShow, _unref(curIndex) == 0]])], 2)], 2)], 2)], 2), _createElementVNode("div", {
        class: _normalizeClass([_ctx.css.bottom, "flex justify_center align_center"])
      }, "copyright©" + _toDisplayString(new Date().getFullYear()) + " 链多多信息技术（重庆）有限公司出品", 3)], 64);
    };
  }
});